import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import cx from 'classnames'
// import { TransitionGroup, CSSTransition } from 'react-transition-group'

// import Layout from '../Layout'

import styles from './styles.module.less'
// import 'src/theme/animation.less'
// import { isIE, logMessage } from 'src/utils/helpers'

// const { Content } = Layout

// const scrollPositions = {}

class Container extends Component {
  // static contextTypes = {
  //   router: PropTypes.object
  // }

  // contentRef = null

  // state = {
  //   routeChanged: true
  // }

/*  componentDidMount() {
    // TODO: PAT-1689 Remove if not needed
    // const { pathname } = this.props.location.pathname
    //
    // if (this.contentRef) {
    //
    //   const scrollTop = !scrollPositions[pathname] ? 0 : scrollPositions[pathname]
    //
    //   try {
    //     if (!isIE()) {
    //       // Scroll to position for newer browsers
    //       this.contentRef.scrollTo(0, scrollTop);
    //     }
    //   } catch (e) {
    //     logMessage('Could not scroll to scroll position. Will try again for older browsers.')
    //
    //     try {
    //       // Scroll to position for older browsers
    //       this.contentRef.scrollTop = scrollTop;
    //     } catch (errorIE) {
    //       logMessage('Could not scroll to scroll position in IE/Edge.')
    //     }
    //   }
    //
    //   this.contentRef.addEventListener('scroll', this.listener)
    // }

    // this.setRouteChanges()
  }*/

  // componentWillUnmount() {
  //   this.contentRef.removeEventListener('scroll', this.listener)
  // }

  // componentDidUpdate(prevProps) {
  //   if (prevProps !== this.props) {
  //     if (this.props.location !== prevProps.location) {
  //       this.setState({ routeChanged: true})
  //
  //       this.setRouteChanges()
  //     }
  //   }
  // }

  // setRouteChanges = () => {
  //   const { applyRouteChanges } = this.props
  //
  //   if (typeof applyRouteChanges === 'function') {
  //     const { router } = this.context
  //     const location = router && router.route.location ? router.route.location : null
  //
  //     // Updates current page URL and CSS classes
  //     applyRouteChanges(location)
  //   }
  // }

  // listener = (element) => {
  //   scrollPositions[this.props.location.pathname] = element.target.scrollTop
  // };

  // setContentRef = (ref) => {
  //   this.contentRef = ref
  // }

  /* renderChildren = (children, className) => {
    return (
      <CSSTransition
        unmountOnExit
        timeout={600}
        classNames="slide"
      >
        <div ref={this.setContentRef} className={className}>{children}</div>
      </CSSTransition>
    )
  } */

  render() {
    const { style } = this.props;
    const className = cx(styles.container, 'ant-layout-content', this.props.className, {
      [styles.fixedTop]: this.props.fixedTop,
      [styles.small]: this.props.small,
      [styles.padder]: this.props.padder,
      [styles.fullHeight]: this.props.fullHeight,
      [styles.desktopBackgroundColor]: this.props.addDesktopBackgroundColor,
    })

    // TODO: [Desktop] Figure out how to do transitions that work on desktop as well

    // TODO: [Desktop] Check if <Content> is needed

    return (
      <div/* ref={this.setContentRef}*/ className={className} style={style ? style : {}}>
        {this.props.children}
      </div>
    )

    /* if (this.state.routeChanged) {
      return (
        <TransitionGroup
          appear={true}
          component={null}>
          { this.renderChildren(this.props.children, className) }
        </TransitionGroup>
      )
    }

    return (
      <Content className={className}>
        { this.renderChildren(this.props.children) }
      </Content>
    ) */
  }
}

Container.defaultProps = {
  fixedTop: true,
  small: false,
  padder: false,
  fullHeight: false,
}

export default Container
